export default __webpack_public_path__ + "static/media/Whirlpool.e4cabcb1.svg";